// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "scripts/" + (chunkId === 3677 ? "dynamic-import-insitepanel" : chunkId) + "." + {"3677":"dedb63742df3988cb599","9185":"2f618f6ba5473bbccc48"}[chunkId] + ".js";
};